import React from "react";
import {
  FaCartPlus,
  FaCreditCard,
  FaInfoCircle,
  FaPlus,
  FaSyncAlt,
} from "react-icons/fa";

export default function DashboardPaymentsHeader({
  helpOpen,
  loading,
  onCreateBoutique,
  onCreateSpecial,
  onToggleHelp,
  onRefresh,
}) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-5 sm:p-6">
        <div className="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Paiements club
            </p>

            <h1 className="mt-1 flex items-center gap-3 text-2xl font-bold text-slate-900 dark:text-white">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
                <FaCreditCard />
              </span>
              Commandes, licences-cotisations & règlements
            </h1>

            <p className="mt-2 max-w-4xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              Centralisez tous les règlements perçus ou en attente : boutique,
              licences, cotisations, réductions, acomptes, paiements en ligne,
              chèques, espèces, virements et rappels automatiques.
            </p>
          </div>

          <div className="flex flex-col gap-2 sm:flex-row xl:justify-end">
            <button
              type="button"
              onClick={onCreateBoutique}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-4 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-[#012f6d] dark:bg-indigo-500 dark:hover:bg-indigo-400"
            >
              <FaPlus />
              Achat boutique
            </button>

            <button
              type="button"
              onClick={onCreateSpecial}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#4CA82F] px-4 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-[#3e8b27] dark:bg-emerald-500 dark:hover:bg-emerald-400"
            >
              <FaCartPlus />
              Licence / cotisation
            </button>

            <button
              type="button"
              onClick={onToggleHelp}
              className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
              aria-expanded={helpOpen}
            >
              <FaInfoCircle />
              {helpOpen ? "Masquer l’aide" : "Aide"}
            </button>

            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
            >
              <FaSyncAlt className={loading ? "animate-spin" : ""} />
              Actualiser
            </button>
          </div>
        </div>

        {helpOpen ? (
          <div className="mt-5 rounded-[24px] border border-sky-200 bg-sky-50 p-4 text-sm leading-6 text-slate-700 dark:border-sky-500/20 dark:bg-sky-500/10 dark:text-slate-200">
            <p className="font-bold text-slate-900 dark:text-white">
              Fonctionnement de la page Paiements
            </p>

            <div className="mt-2 grid gap-3 lg:grid-cols-2">
              <p>
                Les achats boutique correspondent aux articles physiques ou
                services vendus par le club : kimono, passeport sportif, stage,
                textile, événement, etc.
              </p>

              <p>
                Les règlements licence-cotisation permettent de générer un
                paiement global rattaché à un utilisateur, avec plusieurs
                articles, réductions, saison et notification côté adhérent.
              </p>

              <p>
                La colonne autorisation permet d’afficher ou masquer le paiement
                côté utilisateur. C’est utile pour préparer les règlements avant
                de les rendre visibles.
              </p>

              <p>
                Les rappels sont disponibles uniquement pour les paiements non
                clôturés : non réglés, en attente ou partiellement réglés.
              </p>
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
}